import { HttpRequest } from "util/http";
import { userData } from "util/userData";

export interface IPlatformMetric {
  service: string;
  platformIconUrl: string;
  averageRating: IRating;
  commentMoods: ICommentMood[];
  reviewSummary: IReviewSummary;
  averageDaysToRespond: number;
  percentResponded: number;
  totalResponses: number
  totalCoded: number
  positiveNumber: number
}

export interface IRating {
  rating: number;
  reviews: number;
}

export interface ICommentMood {
  name: string;
  y: number;
  color: string;
}

export interface IReviewSummary {
  threeOrLess: number;
  moreThanThree: number;
  total: number;
}

interface IDashboardMetricResponse {
  platform: string;
  platformIconUrl: string;
  averageRating: string;
  reviews: number;
  underFourStars: number;
  overThreeStars: number;
  daysToRespond: number;
  positive: number;
  negative: number;
  neutral: number;
  totalCoded: number;
  percentResponded: number;
  totalResponses: number;
}

export const getDashboardMetrics = (filters = userData.getFilters()) => {
  const method = "POST";
  const data: any = { ...filters };

  return HttpRequest.fetch<IPlatformMetric[]>(
    "/scripts/social_media/getDashboardMetrics",
    { data, method }
  ).then(
    // @ts-ignore
    (res: IDashboardMetricResponse[]) => {
      const platformMetrics: IPlatformMetric[] = [];
      res.map((metric) => {
        let totalCoded =
          parseInt(metric.positive.toString()) +
          parseInt(metric.negative.toString()) +
          parseInt(metric.neutral.toString());
        let percentPositive = (metric.positive / totalCoded) * 100.0;
        let percentNegative = (metric.negative / totalCoded) * 100.0;
        let percentNeutral = (metric.neutral / totalCoded) * 100.0;

        const platform: IPlatformMetric = {
          service: metric.platform,
          platformIconUrl: metric.platformIconUrl,
          averageRating: {
            rating: parseFloat(metric.averageRating),
            reviews: metric.reviews,
          },
          commentMoods: [
            { name: "Positive", y: percentPositive, color: "#0493FC" },
            { name: "Negative", y: percentNegative, color: "#ffaa00" },
            { name: "Neutral", y: percentNeutral, color: "#e7e7e7" },
          ],
          reviewSummary: {
            threeOrLess: metric.underFourStars,
            moreThanThree: metric.overThreeStars,
            total: metric.reviews,
          },
          averageDaysToRespond: metric.daysToRespond,
          percentResponded: metric.percentResponded,
          totalResponses: metric.totalResponses,
          totalCoded: totalCoded,
          positiveNumber: metric.positive,
        };

        platformMetrics.push(platform);
      });

      return platformMetrics;
    });
};
